import React from 'react';
import { motion } from 'framer-motion';
import { PROCESS_STEPS, BRAND_COLOR } from '../constants';

interface ProcessStep {
  id: string;
  title: string;
  desc: string;
  icon: string;
}

const Process: React.FC<{ isDarkMode: boolean }> = ({ isDarkMode }) => {
  return (
    <section id="process" className={`py-32 border-t transition-colors duration-500 ${isDarkMode ? 'bg-black border-white/5' : 'bg-zinc-50 border-zinc-100'}`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-20 text-center">
          <motion.p 
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={`text-[12px] font-black tracking-[0.5em] uppercase mb-4 ${isDarkMode ? 'text-white opacity-40' : 'text-black opacity-40'}`}
          >
            Workflow
          </motion.p>
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={`font-display text-5xl md:text-7xl font-black uppercase tracking-tight ${isDarkMode ? 'text-white' : 'text-black'}`}
          >
            THE <span style={{ color: BRAND_COLOR }}>METHOD.</span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-12 md:gap-8">
          {PROCESS_STEPS.map((step: ProcessStep, idx: number) => (
            <motion.div 
              key={step.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.1 }}
              viewport={{ once: true }}
              className={`relative p-10 group border transition-all duration-500 ${isDarkMode ? 'bg-zinc-900/50 border-white/10 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.5)]' : 'bg-white border-zinc-200 shadow-sm'}`}
            >
              <div 
                className="w-14 h-14 mb-8 flex items-center justify-center rounded-full border transition-colors group-hover:bg-brand group-hover:border-brand"
                style={{ borderColor: isDarkMode ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.1)' }}
              >
                <svg 
                  width="24" height="24" viewBox="0 0 24 24" fill="none" 
                  stroke={isDarkMode ? 'white' : 'black'} strokeWidth="2" 
                  className="group-hover:stroke-black transition-colors"
                >
                  <path d={step.icon} strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <span className="block text-[10px] font-black tracking-[0.3em] text-brand mb-2">{step.id}</span>
              <h3 className={`text-2xl font-display font-black uppercase mb-4 ${isDarkMode ? 'text-white' : 'text-black'}`}>
                {step.title}
              </h3>
              <p className={`text-sm leading-relaxed font-black uppercase ${isDarkMode ? 'text-white' : 'text-black'}`}>
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;